import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/inventory/deployment-manifests_/$id")({
  component: DeploymentManifestDetailRoute,
});

import { DeploymentManifestDetailPage } from "@/components/inventory/DeploymentManifestDetailPage";

function DeploymentManifestDetailRoute() {
  const { id } = Route.useParams();
  return <DeploymentManifestDetailPage manifestId={id} />;
}
